export enum itemToShow {
	None = "None",
	Button = "Button",
	Separator = "Separator",
}
